module.exports = __webpack_public_path__ + "img/newlogo-150.c6aade40.png";